import { Dictionary } from "@quest-finance/quest-fe-shared/dist/common/types/Dictionary";

export const WORKFLOW_TASK = "WORKFLOW_TASK";

export const AUDIT_CATEGORY_LABELS: Dictionary = {
  [WORKFLOW_TASK]: "Workflow Task",
};

export const MODEL_NAME = ["WorkflowTask"];
